import React from "react";

const NdsTypeFilter = (props) => {
    const setValue = (e) => {
        const value = e.target.value;
        props.setFilter({ name: "sumWithoutVat", value: value === "true" });
    };
    return (
        <div className="mb-md-0 report__filters--mr">
            <select
                className="form-control form-control-sm"
                onChange={setValue}
                value={props.values.sumWithoutVat.toString()}
            >
                <option value="false">Стоимость с НДС</option>
                <option value="true">Стоимость с вычетом НДС</option>
            </select>
        </div>
    );
};

export default NdsTypeFilter;
